<mat-form-field *ngIf='field' appearance="outline" [style.width]="field.matFormFieldWidth" [formGroup]="group">
    <!-- <mat-select [(value)]="field.value" [formControlName]="field.name" [multiple]="field.select.mutiple">
        <mat-option *ngFor="let option of field.select.options" [value]="option.value">
            {{option.name}}
        </mat-option>
    </mat-select> -->
    <!-- <mat-select [(value)]="field.value" [formControlName]="field.name" multiple>
        <mat-option *ngFor="let option of field.select.options" [value]="option.value">
            {{option.name}}
        </mat-option>
    </mat-select> -->
    <mat-select [(value)]="field.value" [formControlName]="field.name" [multiple]="field.select.isMultiple" >
        <mat-option *ngFor="let option of field.select.options" [value]="option.value" (click)="click(field.name,option.value, option.name)">
            {{option.name}}
        </mat-option>
    </mat-select>

    <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
    </ng-container>

    <span matSuffix *ngIf="field?.suffix">    
        <ng-container *ngIf="field.suffix.icon; else isNotIcon">
            <mat-icon>{{field.suffix.text}}</mat-icon>
        </ng-container>
        <ng-template #isNotIcon>
            {{field.suffix.text}}
        </ng-template>
    </span>

    <span matPreffix *ngIf="field?.preffix">    
            <ng-container *ngIf="field.preffix.icon; else isNotIcon">
                <mat-icon>{{field.preffix.text}}</mat-icon>
            </ng-container>
            <ng-template #isNotIcon>
                {{field.preffix.text}}
            </ng-template>
        </span>
</mat-form-field>